mutation WorkgroupGroupUpdate($input: WorkgroupGroupUpdateInput!) {
  workgroupGroupUpdate(input: $input) {
    workgroupGroup {
      __typename
      id
      _rowTimestamp
      _isUpdatable
      _isDeletable
      name
      description
      workgroupGroupItems(
        orderBy: CORPORATE_WORKGROUP_BY_WORKGROUP_ID__NAME_ASC
      ) {
        nodes {
          id
          _rowTimestamp
          _isUpdatable
          _isDeletable
          workgroupId
          corporateWorkgroup {
            name
          }
        }
      }
    }
  }
}
